// See https://codepen.io/GeoffreyCrofte/pen/zYrxKRe
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'code'];
  static values = {
    backspace: 8,
    tab: 9,
    shift: 16,
    ctrl: 17,
    alt: 18,
    arrowLeft: 37,
    meta: 224, // Command-key on macOS
  };

  connect() {
    this.inputTargets[0].focus();
  }

  handleInput(event) {
    const keyCode = event.keyCode;
    const input = event.target;
    const value = input.value;
    const previous = input.previousElementSibling;
    const next = input.nextElementSibling;

    if (
      keyCode === this.shiftValue ||
      keyCode === this.tabValue ||
      keyCode === this.metaValue ||
      keyCode === this.altValue ||
      keyCode === this.ctrlValue
    ) {
      return;
    }

    if (
      (keyCode === this.backspaceValue || keyCode === this.arrowLeftValue) &&
      previous &&
      previous.tagName === 'INPUT'
    ) {
      previous.select();
      return;
    }

    if (value.length > 1) {
      this.fillNext(input, value.slice(0, 6));
    } else {
      if (!this.validNumber(value)) return false;

      if (next) {
        next.select();
      }
    }

    this.updateCodeTarget();
  }

  validNumber(char) {
    return /^\d{1}$/.test(char);
  }

  fillNext(input, remainingText) {
    const value = remainingText.slice(0, 1);
    if (!this.validNumber(value)) {
      input.value = '';
      return false;
    }

    input.value = value;
    if (input.nextElementSibling && remainingText.length > 1) {
      this.fillNext(
        input.nextElementSibling,
        remainingText.slice(1, remainingText.length)
      );
    } else {
      this.updateCodeTarget();
    }
  }

  updateCodeTarget() {
    const code = Array.from(this.inputTargets)
      .map((input) => input.value)
      .join('');
    this.codeTarget.value = code;
  }
}
